<template>
  <base-dialog v-model="dialog.show" max-width="500px">
    <template v-slot:title> {{ dialog.title }} Bản đồ </template>
    <base-form ref="form" @submit.stop="onSubmit">
      <FieldGroup v-model="dialog.form.title" autofocus :error-messages="dialog.errors.title" label="Nhập tên" required
        @focus="dialog.errors.title = ''"></FieldGroup>
      <FieldGroup v-model="dialog.form.type" :error-messages="dialog.errors.type" :items="types" label="Loại" required
        type-input="v-select" @focus="dialog.errors.type = ''"></FieldGroup>
      <template v-if="dialog.form.type == 'raster'">
        <FieldGroup v-model="dialog.form.meta.minzoom" label="Mức thu phóng tối thiểu" type="number" min="0"
          placeholder="0" max="24"></FieldGroup>
        <FieldGroup v-model="dialog.form.meta.maxzoom" label="Mức thu phóng tối đa" type="number" placeholder="24"
          min="0" max="24"></FieldGroup>
      </template>

      <FieldGroup v-model="dialog.form.link" :error-messages="dialog.errors.link" label="Đường dẫn" required
        @focus="dialog.errors.link = ''"></FieldGroup>
      <FieldGroup>
        <template>
          <FieldFile v-model="dialog.form.thumbnail" accept="image/*" title="Ảnh đại diện"
            :error-messages="dialog.errors.thumbnail" label="Chọn hoặc kéo thả để tải hình ảnh lên" required
            @focus="dialog.errors.thumbnail = ''">
          </FieldFile>
        </template>
      </FieldGroup>
    </base-form>
    <template v-slot:extra-btn>
      <base-button color="primary" :loading="dialog.loading" @click="onSubmit">
        {{ dialog.title }}
      </base-button>
    </template>
  </base-dialog>
</template>

<script>
import FieldFile from '@components/field/field-image-input.vue'
import { API_BASEMAP } from '@/src/service/api'
import { copyByJson } from '@/src/utils'
export default {
  components: { FieldFile },
  props: {},
  data: () => ({
    types: ['vector', 'raster'],
    dialog: {
      show: false,
      form: { meta: {} },
      errors: {},
      title: '',
      type: '',
      loading: false,
    },
  }),
  computed: {},
  methods: {
    open(item, type) {
      this.dialog.show = true
      this.dialog.form = Object.assign({ meta: {} }, copyByJson(item))
      this.dialog.title = this.$t('actions.' + type)
      this.dialog.type = type
      this.dialog.errors = {}
      this.dialog.loading = false
    },
    async onSubmit() {
      if (!(await this.$refs['form'].validate())) {
        return false
      }
      try {
        this.dialog.loading = false
        let res = (this.dialog.type == 'update')
          ? await API_BASEMAP.update(
            this.dialog.form.id,
            this.dialog.form)
          : await API_BASEMAP.create(
            this.dialog.form)
        if (res && !res.error) {
          this.$emit('reset');
        }
        if (
          res &&
          res.error &&
          res.error.response &&
          res.error.response.status == 422
        ) {
          const { response } = res.error
          this.dialog.errors = response.data.errors
        }
      } finally {
        this.dialog.loading = false
        this.dialog.show = false
      }
    },
  },
}
</script>

<style scoped>

</style>
